import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
//import internal / external components and containers
import { Box } from "@mui/material";
import MyClubsContainer from "../MyClubsContainer";
import EvaluationUpcoming from "../EvaluationUpcoming";
import EvaluationProjects from "../EvaluationProjects";
import { colors } from "../../common/pallette/colors";
import { useSelector } from "react-redux";

const JLHomeContainers = () => {
  const [expandedContainer, setExpandedContainer] = React.useState({
    upcoming: false,
    projects: false,
  });
  const displayUpcomingData = useSelector(
    (state: any) => state.common.displayUpcoming
  );
  const displayProjectsData = useSelector(
    (state: any) => state.common.displayProjects
  );
  const upcomingElemnt: any = useRef(null);
  const projectsElement: any = useRef(null);
  const [upcomingHeight, setUpcomingHeight] = useState(0);
  const [projectsHeight, setProjectsHeight] = useState(0);

  useEffect(() => {
    if (upcomingElemnt.current) {
      setUpcomingHeight(upcomingElemnt?.current?.clientHeight);
    }
    if (projectsElement.current) {
      setProjectsHeight(projectsElement?.current?.clientHeight);
    }
  }, []);
  // Height is driven only by expand/collapse — never by filtered result counts,
  // so search does not shrink or collapse the calendar panels.
  const generateHeight = (root: string) => {
    if (!expandedContainer.upcoming && !expandedContainer.projects) {
      return "49.25%";
    }
    if (
      (expandedContainer.upcoming && root === "upcoming") ||
      (expandedContainer.projects && root === "projects")
    ) {
      return "79.25%";
    }
    return "19.25%";
  };

  return (
    <React.Fragment>
      <Box className="homeContainersWrapper">
        <Box className="myClubsWrapper">
          <MyClubsContainer />
        </Box>
        <Box className="homeRightWrapper">
          <Box
            sx={{ height: generateHeight("upcoming"), mb: 3.5 }}
            ref={upcomingElemnt}
          >
            <EvaluationUpcoming
              isExpanded={expandedContainer.upcoming}
              disableExpand={false}
              setIsExpanded={() => {
                !expandedContainer.upcoming
                  ? setExpandedContainer({ upcoming: true, projects: false })
                  : setExpandedContainer({
                      ...expandedContainer,
                      upcoming: false,
                    });
              }}
            />
          </Box>
          <Box
            sx={{ height: generateHeight("projects") }}
            ref={projectsElement}
          >
            <EvaluationProjects
              isExpanded={expandedContainer.projects}
              disableExpand={false}
              setIsExpanded={() => {
                !expandedContainer.projects
                  ? setExpandedContainer({ upcoming: false, projects: true })
                  : setExpandedContainer({
                      ...expandedContainer,
                      projects: false,
                    });
              }}
            />
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};

export default JLHomeContainers;
